import * as React from 'react';

// types
import { IEndOperationDispatchProps, IEndOperationStoreProps } from 'modules/end-operation/end-operation.types';

// component
import EndOperationContent from './end-operation-content';
// utils
import { isBeforeExpiration } from '@sitegen/common/classes/friends-referral-api/friends-referral-api.utils';
import URLParams from 'utils/url-params';
import { REF_ID_URL_PARAM } from '../../widgets/friends-referral/modules/friends-referral-invitee/friends-referral-invitee.constants';
import { isValidBySoftClosingMode } from './end-operation.utils';

export class EndOperation extends React.PureComponent<IEndOperationProps> {
    private readonly isValid: boolean;

    constructor(props: IEndOperationProps) {
        super(props);
        const invitationId: string | null = URLParams().get(REF_ID_URL_PARAM);
        const { softCloseMode, isRegistered, endDate } = props;

        this.isValid = isBeforeExpiration(endDate) && isValidBySoftClosingMode(invitationId, softCloseMode, isRegistered);
    }

    public componentDidMount() {
        this.props.emitOperationEndingStatus(this.isValid);
    }
    public render(): JSX.Element | null {
        const {
            children,
            shouldInheritStyles = false
        } = this.props;

        if (this.isValid) {
            return null;
        }

        return children ? <>{children}</> : <EndOperationContent shouldInheritStyles={shouldInheritStyles} />;
    }
}

export type IEndOperationProps = IEndOperationDispatchProps & IEndOperationStoreProps;

export default EndOperation;
